var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAds4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 58,
    viewBox: "0 0 59 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "browsing_8199448 1",
    clipPath: "url(#clip0_1461_14124)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    transform: "translate(0.5)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.6842 54.3412H4.31578C2.21112 54.3412 0.5 52.6298 0.5 50.5255V7.47594C0.5 5.37128 2.21112 3.66016 4.31578 3.66016H54.6842C56.7889 3.66016 58.5 5.37162 58.5 7.47594V50.5255C58.5 52.6301 56.7885 54.3412 54.6842 54.3412ZM47.2222 30.8308H11.7778C10.9003 30.8308 10.9003 29.4976 11.7778 29.4976H47.2222C48.0997 29.4976 48.1001 30.8308 47.2222 30.8308ZM47.2222 24.6816H11.7778C10.8999 24.6816 10.8999 23.3484 11.7778 23.3484H47.2222C48.0997 23.3484 48.1001 24.6816 47.2222 24.6816ZM47.834 43.4927H40.5266V35.1274H47.8336C48.2017 35.1274 48.5004 35.4265 48.5004 35.7942V42.8263C48.5011 43.1936 48.202 43.4927 47.8343 43.4927H47.834ZM21.8742 36.8229C19.7237 36.8229 18.6399 39.4394 20.1604 40.9602C21.1082 41.908 22.6406 41.9077 23.5884 40.9602C25.1058 39.4428 24.0197 36.8233 21.8742 36.8233V36.8229ZM39.1934 43.4927H27.532C29.2672 41.1345 29.552 37.7548 27.6516 35.1274H39.1934V43.4927ZM16.0292 43.4927H11.1667C10.7987 43.4927 10.4999 43.1936 10.4999 42.8263V35.7939C10.4999 35.4258 10.7987 35.1271 11.1667 35.1271H16.0969C14.2219 37.7167 14.4687 41.0346 16.1353 43.387L16.9302 42.5921C15.4556 40.378 15.4348 37.2297 17.6462 35.0187C19.9823 32.6826 23.7661 32.6826 26.1022 35.0187C29.8507 38.7672 27.1741 45.2259 21.8742 45.2259C20.6508 45.2259 19.5677 44.8823 18.6708 44.3087L15.2428 47.7367C15.0131 47.9664 14.7035 48.0949 14.3786 48.0949C13.2948 48.0949 12.746 46.7763 13.5144 46.0079L16.0289 43.4934L16.0292 43.4927ZM21.8742 35.7116C18.7368 35.7116 17.1565 39.5271 19.3747 41.7456C20.7561 43.127 22.9926 43.127 24.3741 41.7456C26.5896 39.5301 25.0066 35.7116 21.8742 35.7116ZM35.2301 9.18026H31.272C30.3945 9.18026 30.3948 7.84705 31.272 7.84705H35.2301C36.1076 7.84705 36.1076 9.18026 35.2301 9.18026ZM43.7025 9.18026H39.7439C38.8661 9.18026 38.8668 7.84705 39.7439 7.84705H43.7025C44.5799 7.84705 44.5803 9.18026 43.7025 9.18026ZM52.1748 9.18026H48.2166C47.3388 9.18026 47.3391 7.84705 48.2166 7.84705H52.1748C53.0526 7.84705 53.0523 9.18026 52.1748 9.18026ZM56.0552 14.3887H2.94451V50.5255C2.94451 51.2813 3.55997 51.8961 4.31578 51.8961H54.6842C55.44 51.8961 56.0548 51.2813 56.0548 50.5255V14.3884L56.0552 14.3887Z",
    fill: "url(#paint0_linear_1461_14124)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1461_14124",
    x1: 0.50034,
    y1: 29.0007,
    x2: 58.4997,
    y2: 29.0007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5329"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1461_14124"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAds4);
export default __webpack_public_path__ + "static/media/ads4.d4e6e0a4a1d329dc337b70f6a37642ba.svg";
export { ForwardRef as ReactComponent };